import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";

/* -------- packages -------- */
import { Container, Spinner } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { clearSectorErrors, fetchSectorRequest, updateSectorRequest } from "../../store/actions";
/* ------------------------- */

/* -------- intern functions -------- */
import { hasAllRights } from "../../utils/userTools";
/* ------------------------- */

/* -------- components -------- */
import Breadcrumb from "../../components/ui/Breadcrumbs";
import DynamicForm from "../../components/ui/Form";
import { getActivities, getErrorFromResponse } from '../../utils/utils';
import ErrorHandler from '../../components/ui/Error/ErrorHandler';
/* ------------------------- */


export default function SectorNewEditPage() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parameters = useSelector(state => state.Parameters);

  document.title = `${t('sectors')} | ${parameters.appName}`; //meta title
  
  const { id } = useParams(); // Get the id from the URL  

  const { sector, loadingSector, errorSector } = useSelector(state => state.Sectors);

  useEffect(() => {
    if (id && !isNaN(id)) {
      dispatch(fetchSectorRequest(id));
    }
  }, [dispatch]);


  ErrorHandler(errorSector, clearSectorErrors);
  
  const fields = [
    { key: 'lib', type: 'text', required: true },
  ];
      
    const disposition = [
      ['lib'],
      [''],
  ];

  
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    const status = document.getElementById("status");
    
    if (loadingSector) {
      if (preloader) preloader.style.display = "block";
      if (status) status.style.display = "block";
    } else {
      if (preloader) preloader.style.display = "none";
      if (status) status.style.display = "none";
    }
  }, [loadingSector]);
  
  return (
      <div className="page-content vh-100 overflow-auto">
        <Container fluid>
          <Breadcrumb title={t("sector")} breadcrumbItem={t("sector")} url={"/sectors"}/>
          <DynamicForm
            fields={fields} 
            initialValues={id && !isNaN(id) ? (sector || {}) : {}} 
            editFunction={updateSectorRequest}
            isEdit={id}
            isLoading={loadingSector}
            error={errorSector} // Pass the error to DynamicForm
            prefListName={"sector"}
            disposition={disposition}
          />
        </Container>
        <ToastContainer />
      </div>
  );
};

